import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';

import { PROFILE_ROLE } from '@app-units/models/profile/profile';
import { AuthService } from '@ss-core/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class ClientPortalOfferedOrdersGuard
  implements CanLoad, CanActivate, CanActivateChild
{
  constructor(private authService: AuthService, private router: Router) {}

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    if (this.shouldRedirect()) {
      this.router.navigate(['/client_portal_home']);
      return false;
    }

    return true;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.shouldRedirect()
      ? this.router.createUrlTree(['/client_portal_home'])
      : true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.shouldRedirect()
      ? this.router.createUrlTree(['/client_portal_home'])
      : true;
  }

  private shouldRedirect(): boolean {
    const authUser = this.authService.authUser();

    if (!authUser || !authUser.profile) {
      return false;
    }

    return authUser.profile.role === PROFILE_ROLE.CLIENT;
  }
}
